// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterLinks_title__dkuld","root":"FooterLinks_root__GBTJV","list":"FooterLinks_list__Pie5K","list-item":"FooterLinks_list-item__qsM7t"};